import React from 'react';
import truckImage from '../../assets/images/project-1064005.jpg';

export const HeroHome = () => {
  return (
    <section className="HeroSection bg-white overflow-hidden w-full mx-auto flex items-center justify-center pt-[113px] max-w-[1920px] xl:max-w-[2560px] 2xl:max-w-[3840px]">
      {/* Background Image and Text Content Container */}
      <div className="relative w-full h-[700px] sm:h-[850px] lg:h-[992px] 2xl:h-[1100px] flex items-center justify-center">
        {/* Background Image */}
        <img
          src={truckImage}
          alt="Fast and safe transportation services"
          className="w-full h-full object-cover absolute inset-0"
          style={{ aspectRatio: '1781.04 / 992' }}
          loading="lazy"
        />

        {/* Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(245deg, rgba(0, 0, 0, 0) 23.99%, #000 99.36%)',
            mixBlendMode: 'multiply',
          }}
        />

        {/* Text Content */}
        <div className="relative z-20 flex flex-col gap-6 w-[90%] max-w-[780px] items-center text-center px-4 sm:px-8 xl:px-20 2xl:px-32">
          {/* Heading */}
          <h1 className="text-white font-bold leading-tight text-[36px] sm:text-[48px] md:text-[60px] lg:text-[72px] 2xl:text-[86px]">
            <span className="text-white">All</span>
            <span className="text-[#5bc0fe]"> Solutions </span>
            <span className="text-white">Under One Roof</span>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default HeroHome;
